import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  initialize() {
    this.currentPageIndex = 0;
    this.isLoading = false;
    this.requestQueue = null;
    this.resetForcedSearchInitialization = false;
  }

  page(event) {
    const element = event.currentTarget;
    this.currentPageIndex = element.dataset.pageIndex;
    this.load();
  }

  load() {
    if (this.isLoading) {
      this.requestQueue = this.getRequestParams();
      return;
    }

    const { newUrl, filterParams, paramsJSON } = this.getRequestParams();
    if (paramsJSON.page_name == "search" && event.type == "pos/places_changed") {
      let locationUrl = new URL(this.data.get("location"));
      this.searchLocation(locationUrl, filterParams, paramsJSON);
    } else {
      this.applyFilters(newUrl, filterParams, paramsJSON);
    }
  }

  getRequestParams() {
    const filterPrefix = this.data.get("filter");
    const urlElements = document.querySelectorAll("[name^='" + filterPrefix + "']");
    const paramsJSON = {};
    urlElements.forEach((e) => {
      let value, name;
      name = e.name.replace(filterPrefix, "").replaceAll("[", "").replaceAll("]", "");
      if (e.nodeName === "SELECT") {
        const selected = [];
        for (let option of e.options) {
          if (option.selected && !!option.value) {
            selected.push(option.value);
          }
        }
        value = selected;
      } else if (name === "location_type") {
        let selected = []
        if (e.type === "checkbox") {
          for (let option of $("#search_location_type :checkbox:checked")) {
            if (option.checked && !!option.value) {
              selected.push(option.value);
            }
          }
          value = selected
        } else {
          value = e.value.split(" ");
        }

      } else if (e.type === "checkbox") {
        const selected = [];

        if (name === "space_usage_type") {
          for (let option of $("#search_space_usage_type_ :checkbox:checked")) {
            if (option.checked && !!option.value) {
              selected.push(option.value);
            }
          }

          for (let option of $("#search_space_usage_type_homepage :checkbox:checked")) {
            if (option.checked && !!option.value) {
              selected.push(option.value);
            }
          }
        }

        if (name === "industry") {
          for (let option of $("#search_industry :checkbox:checked")) {
            if (option.checked && !!option.value) {
              selected.push(option.value);
            }
          }
        }

        value = selected;
      } else if (e.type !== "checkbox") {
        value = e.value;
      }
      if (Array.isArray(value) && !value.length) return;
      paramsJSON[name] = value;
    });

    const filterParams = new URLSearchParams(Object.entries(paramsJSON)).toString();
    let newUrl = new URL(this.data.get("url"));
    newUrl.searchParams.set("page", this.currentPageIndex);
    if (this.resetForcedSearchInitialization) {
      newUrl.searchParams.delete("forced_search_initialization");
    }
    this.resetForcedSearchInitialization = true;

    return { newUrl, filterParams, paramsJSON };
  }

  applyFilters(newUrl, filterParams, paramsJSON) {
    this.isLoading = true;
    fetch(`${newUrl}&${filterParams}`, { method: this.method })
      .then((response) => response.text())
      .then((html) => {
        // `id` is required because it's used to
        // known the target as well.
        let $newEl = $(html);
        let id = $newEl.attr("id");
        let $el = $(`#${id}`);

        if (paramsJSON.page_name == "search") {
          let listing_id = $newEl[0].id;
          let map_id = $newEl[2].id;

          let $listing_el = $(`#${listing_id}`);
          let $map_el = $(`#${map_id}`);

          if ($listing_el.length) {
            $listing_el.replaceWith($newEl[0]);
          }
          if ($map_el.length) {
            $map_el.replaceWith($newEl[2]);
          }
        } else if ($el.length) {
          $el.replaceWith($newEl);
          let listing_count = $newEl[0].getElementsByClassName("listings__count")[0].innerHTML;
          if (document.getElementById("listing__heading") && document.getElementsByClassName("listings__total").length != 0) {
            document.getElementsByClassName("listings__total")[0].innerText = `(${listing_count})`;
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
        if (this.requestQueue) {
          const { newUrl, filterParams, paramsJSON } = this.requestQueue;
          this.requestQueue = null;
          this.applyFilters(newUrl, filterParams, paramsJSON);
        }
      });
  }

  searchLocation(locationUrl, filterParams, paramsJSON) {
    this.isLoading = true;
    fetch(locationUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paramsJSON),
    })
      .then((response) => response.text())
      .then((html) => {
        let url = window.location.pathname.split("/");
        url.pop();
        url.push(JSON.parse(html).data.uuid);
        url = url.join("/");
        window.location = url;
      })
      .finally(() => {
        this.isLoading = false;
        if (this.requestQueue) {
          const { newUrl, filterParams, paramsJSON } = this.requestQueue;
          this.requestQueue = null;
          this.applyFilters(newUrl, filterParams, paramsJSON);
        }
      });
  }

  teardown() {}

  get method() {
    return this.data.get("method") || "GET";
  }
}
